import { useState, useCallback } from 'react';

const INITIAL_STATE = {
  isOpen: false,
  step: 'email', // 'email' | 'pix' | 'processing' | 'success'
  selectedBook: null,
  email: '',
  emailError: '',
  error: '',
  isLoading: false,
  orderId: '',
  pixCode: '',
  qrCodeImage: '',
  processingTimer: 0,
  downloadToken: '',
  termsAccepted: false,
};

export const useModalState = () => {
  const [state, setState] = useState(INITIAL_STATE);

  const updateState = useCallback((updates) => {
    setState(prev => ({ ...prev, ...updates }));
  }, []);

  const resetState = useCallback(() => {
    setState(INITIAL_STATE);
  }, []);

  return { state, updateState, resetState };
};